import { createSlice } from "@reduxjs/toolkit";

export const shiftReportSelectionSlice = createSlice({
    name:"shiftReportSelection",
    initialState:{
        selectedReport: null
    },
    reducers:{
         setSelectedReport: (state, action) => {
      state.selectedReport = action.payload;
    },
    clearSelectedReport: (state) => {
      state.selectedReport = null;
    },
    }
})
export const { setSelectedReport, clearSelectedReport }=shiftReportSelectionSlice.actions;
export default shiftReportSelectionSlice.reducer;